<template>
	<tr class="border-b">
		<td class="flex items-center py-6 px-4">
			<div class="flex flex-col justify-center w-[80px] h-[80px] shrink-0 mr-6">
				<img
					src="https://cdn11.bigcommerce.com/s-nuj3c/stencil/29299650-2b9e-013d-ca92-06d759ad9f37/e/15c6ecf0-25f0-013d-e4f6-1e7f4d7752a0/img/GiftCertificate.png"
					class="w-full max-w-[80px] max-h-[80px] object-contain"
				/>
			</div>
			<div class="flex flex-col text-start px-4">
				<div class="items-center cursor-pointer text-ihh-dark-salmon hover:text-ihh-salmon underline underline-offset-2 font-semibold">Gift Certificate</div>
				<div class="text-ihh-slate-gray mt-0 pt-0 mb-2 items-top text-xs">
					<div>
						<span>Recipient: </span>
						<span class="font-normal">{{ certificate?.recipient?.name }}</span>
					</div>
					<div>
						<span>Email: </span>
						<span class="font-normal">{{ certificate?.recipient?.email }}</span>
					</div>
				</div>
			</div>
		</td>
		<td class="py-6 px-4 text-center text-ihh-slate-gray">${{ certificate.amount?.toFixed(2) }}</td>
		<td class="py-6 px-4 text-center text-ihh-slate-gray font-semibold">
			<div class="flex w-full justify-center">
				<div class="flex w-28 justify-around max-w-[100px]">
					<button
						@click="emitReduceQty"
						class="shadow shadow-ihh-midnight-gray/20 m-auto flex w-5 h-5 rounded-full drop-shadow-2xl shadow-black bg-white items-center justify-center"
					>
						-
					</button>
					<div class="m-auto text-sm">{{ certificate.quantity }}</div>
					<button
						@click="emitIncreaseQty"
						class="shadow shadow-ihh-midnight-gray/20 m-auto flex w-5 h-5 rounded-full drop-shadow-2xl shadow-black bg-white items-center justify-center"
					>
						+
					</button>
				</div>
			</div>
		</td>
		<td class="py-6 px-4 ml-4 text-center text-ihh-slate-gray">
			<div class="flex w-full justify-center">
				<div class="flex m-auto items-center space-x-4">
					<span> ${{ (certificate.amount * certificate.quantity).toFixed(2) }} </span>
				</div>
			</div>
		</td>
		<td class="py-6 px-4 ml-4 text-center text-ihh-slate-gray">
			<div class="flex w-full justify-center m-auto gap-x-2 sm:gap-x-6">
				<div>
					<button
						@click="emitRemoveCert"
						class="flex group w-7 h-7 p-2 justify-around z-10 hover:bg-ihh-slate-gray bg-ihh-gray/20 rounded-full font-bold text-xl text-ihh-midnight-gray"
					>
						<div class="m-auto items-center flex w-full justify-center">
							<div class="rotate-45 absolute bg-ihh-midnight-gray group-hover:bg-ihh-white py-[0.5px] rounded px-1"></div>
							<div class="-rotate-45 bg-ihh-midnight-gray group-hover:bg-ihh-white py-[0.5px] rounded px-1"></div>
						</div>
					</button>
				</div>
			</div>
		</td>
	</tr>
</template>

<script>
export default {
	name: 'CartCertificateDesktop',
	props: {
		certificate: {
			type: Object,
			required: true,
			validator: (cert) => 'amount' in cert && 'quantity' in cert && 'recipient' in cert,
		},
		index: {
			type: Number,
			required: true,
		},
	},
	methods: {
		emitReduceQty() {
			this.$emit('reduce-qty', this.index)
		},
		emitIncreaseQty() {
			this.$emit('increase-qty', this.index)
		},
		emitRemoveCert() {
			this.$emit('remove-cert', this.index)
		},
	},
}
</script>
